<template>
    <div class="login">
        <div class="row justify-content-center 100vh align-items-center full-height ml-0 mr-0 pr-0 pl-0">
            <div class="col-lg-3">
                <img class="logo" src="https://promagic.hu/wp-content/uploads/2019/07/cropped-logo_pm_new_l.jpg">
                <h4 class="pt-2 text-center">Admin bejelentkezés</h4>
                <b-form-group
                    id="fieldset-1"
                    description="Add meg e-mail címed."
                    label-for="input-1"
                    >
                    <b-form-input id="input-1" placeholder="E-mail" v-model="email_login" trim></b-form-input>
                </b-form-group>
                <b-form-group
                    id="fieldset-2"
                    description="Add meg e-mailhoz tartozó jelszavad."
                    label-for="input-2"
                    >
                    <b-form-input type="password" placeholder="Jelszó" v-model="password_login" trim></b-form-input>
                </b-form-group>
                <p class="text-center"><b-button @click="login" variant="outline-success" class="w-100">Bejelentkezés</b-button></p>
            </div>
        </div>
    </div>
</template>
<script>

import axios from 'axios'
import router from "../router"
export default {

  name: 'login',
  data() {
      return {
          email_login:null,
          password_login:null
      } 
    },
    computed: {
      
    },
    methods: {
        login(){
            if(this.email_login == "" || this.password_login == ""){
                this.$swal('Hiba történt', 'Minden mező kitöltése kötelező!', 'error');
            }else{
                this.loginTest(this.email_login, this.password_login);
            }
        },
        loginTest(email,password){
            const params = new URLSearchParams();
            params.append('email', email);
            params.append('password', password);
            axios({
                method: 'post',
                url: process.env.VUE_APP_LOGIN_API,
                data:params
            }).then((response) => {
                if(response.data == ""){
                    this.$swal('Hiba történt', 'Hibás belépési adatokat adott meg!', 'error');
                }else{
                    this.$session.set('id',response.data)
                    router.push({ path: `/` })
                }
            })
        },
        thisUserLogged(){
            if(this.$session.has('id')){
                router.push({ path: `/` })
            }
        }
    },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.full-height{
    height: 100vh;
}
.logo{
    width: 25%;
    height: auto;
    display: block;
    margin: 0 auto;
}
</style>
